import React, { useState, useEffect } from 'react';
import { Box, TextField, Grid } from '@mui/material';
import AutocompleteWithClear from '../../../components/AutocompleteWithClear';
import { useAuth } from '../../../contexts/AuthContext';
import db from '../../../services/db';

function DadosGerais({ data, onDataChange, onConditionChange, disableFields }) {
  const { user } = useAuth();
  const [clientes, setClientes] = useState([]);
  const [naturezasOperacao, setNaturezasOperacao] = useState([]);
  const [formasPagamento, setFormasPagamento] = useState([]);
  const [condicoesPagamento, setCondicoesPagamento] = useState([]);
  const [filteredCondicoesPagamento, setFilteredCondicoesPagamento] = useState([]);
  const [localData, setLocalData] = useState(data);

  useEffect(() => {
    setLocalData(data);
    console.log('rdop', data)
  }, [data]);

  useEffect(() => {
    const fetchData = async () => {
      const [
        loadedClientes,
        loadedNaturezas,
        loadedFormasPagamento,
        loadedCondicoesPagamento,
      ] = await Promise.all([
        db.clientes.toArray(),
        db.tiposOperacao.toArray(),
        db.formasPagamentos.toArray(),
        db.condicaoPagamento.toArray(),
      ]);
      console.log(db.clientes.toArray())
      setClientes(loadedClientes);
      setNaturezasOperacao(loadedNaturezas);
      setFormasPagamento(loadedFormasPagamento);
      setCondicoesPagamento(loadedCondicoesPagamento);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (user?.vendedorModel?.nome) {
      setLocalData((prevData) => ({
        ...prevData,
        vendedor: user.vendedorModel.nome,
      }));
    }
  }, [user]);

  const applyMask = (value, mask) => {
    if (!value) return ''; // Permitir apagar todo o campo

    let i = 0;
    const onlyNumbers = value.replace(/\D/g, '');
    return mask.replace(/9/g, () => onlyNumbers[i++] || '');
  };

  const handleChange = async (field, value) => {
    console.log('aq rapaliga')
    const updatedData = { ...localData, [field]: value };
    console.log(value);
    if (field === 'cliente' && value) {
      
      const cidadeData = await db.cidades.where({nome: ""+value.cidade, estado: value.siglaEstado}).first();

      console.log(cidadeData)
      const estadoCliente = cidadeData.estado; // Estado do cliente selecionado

      // Filtra os CFOPs conforme a regra de estados
      const cfopsFiltrados = await db.tiposOperacao
        .filter((cfop) => {
          if (estadoCliente === user.matriz.estadoMatriz) {
            return cfop.numero.startsWith('5');
          } else {
            return cfop.numero.startsWith('6');
          }
        })
        .toArray();

      // Atualiza a lista de Natureza de Operação com os CFOPs filtrados
      setNaturezasOperacao(cfopsFiltrados);
      handleChange('naturezaOperacao', '');
    }
    

    setLocalData(updatedData);
    onDataChange(updatedData);
  };

  useEffect(() => {
    if (localData.formaPagamento) {
      const formaSelecionada = localData.formaPagamento.descricao.toLowerCase();
      const mapeamentoFormasCondicoes = {
        dinheiro: 'a vista',
        'boleto bradesco': 'boleto',
        pix: 'a vista',
        cheque: 'cheque',
        troca: 'troca',
        bonificacao: 'bonificacao',
      };
      const condicaoEsperada = mapeamentoFormasCondicoes[formaSelecionada] || '';
      const filtradas = condicoesPagamento.filter((cond) =>
        cond.descricao?.toLowerCase().includes(condicaoEsperada)
      );

      setFilteredCondicoesPagamento(filtradas);
    } else {
      setFilteredCondicoesPagamento([]);
    }
  }, [localData.formaPagamento, condicoesPagamento]);

  const handleConditionSelect = (selectedOption) => {
    // Obtém os dias da condição de pagamento
    const dias = selectedOption.dias
      ? selectedOption.dias.split(',').map((dia) => parseInt(dia.trim(), 10))
      : [];
    const enableParcelas = dias.length > 0;

    let parcelas = [];
    if (enableParcelas) {
      const valorTotal = parseFloat(localData.valorTotal || 0);
      const parcelaValorBase = valorTotal / dias.length;

      // Arredonda o valor base para duas casas decimais
      const parcelaValor = parseFloat(parcelaValorBase.toFixed(2));

      // Calcula a diferença devido ao arredondamento
      const totalParcelas = parcelaValor * dias.length;
      const diferenca = parseFloat((valorTotal - totalParcelas).toFixed(2));

      // Gera as parcelas com os dias fornecidos
      const dataPedido = new Date(
        localData.dataPedido || new Date().toISOString().split('T')[0]
      );
      parcelas = dias.map((dia, index) => {
        let vencimento = new Date(dataPedido);
        vencimento.setDate(dataPedido.getDate() + dia + 1);
        console.log(dataPedido.getDate());
        const valor =
          index === dias.length - 1
            ? parseFloat((parcelaValor + diferenca).toFixed(2)) // Ajusta a última parcela
            : parcelaValor;

        return {
          numero: index + 1,
          dataVencimento: vencimento.toISOString().split('T')[0],
          valor: valor.toFixed(2),
        };
      });
    }

    onConditionChange({ enableParcelas, parcelas });
    handleChange('condicaoPagamento', selectedOption);
  };

  const getCurrentDate = () => new Date().toISOString().split('T')[0];
  function removeMask(valor = '') {
    return valor.replace(/\D/g, '');
  }
  return (
    <>
      {localData.cliente && (
        <Grid container spacing={2} sx={{ mb: 1, mt: 2 }}>
          <Grid item xs={6}>
            <TextField
              label="Documento"
              variant="outlined"
              size="small"
              fullWidth
              value={
                applyMask(
                  localData.cliente.documento,
                  localData.cliente.documento?.length === 11
                    ? '999.999.999-99'
                    : '99.999.999/9999-99'
                ) || ''
              }
              disabled
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Cidade"
              variant="outlined"
              size="small"
              fullWidth
              InputProps={{ readOnly: true }}
              value={`${localData.cliente.cidade} - ${localData.cliente.siglaEstado}`}
              disabled
            />
          </Grid>
        </Grid>
      )}





      <Grid container spacing={1} sx={{ mb: 1, mt: 1 }}>
        <Grid item xs={6}>
          <TextField
            label="Número"
            variant="outlined"
            size="small"
            fullWidth
            InputProps={{ readOnly: true }}
            value={localData.numeroPedido || ''}
            disabled
            onChange={(e) => handleChange('nr', e.target.value)}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Data Pedido"
            type="date"
            variant="outlined"
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={localData.dataPedido || getCurrentDate()}
            disabled
            onChange={(e) => handleChange('dataPedido', e.target.value)}
          />
        </Grid>
      </Grid>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2,mt:2 }}>
        <AutocompleteWithClear
          label="Cliente"
          options={clientes}
          getOptionLabel={(option) => {
            if (!option) return '';
  
            // Verifica se é físico ou jurídico analisando o documento
            const docSemMascara = removeMask(option.documento || '');
            const isFisico = docSemMascara.length === 11;
  
            // Se for físico, exibir `nome`; se for jurídico, exibir `razaoSocial` ou, 
            // se não tiver, usa `nome` como fallback
            const nomeOuRazao = isFisico
              ? option.nome
              : option.razaoSocial || option.nome;
  
            // Retorna o formato "idCliente - nome/razaoSocial"
            return `${(option.codigo== null?'cliente offline ':option.codigo)} - ${nomeOuRazao}`;
          }}
          value={localData.cliente || ''}
          onChange={(newValue) => handleChange('cliente', newValue)}
          disabled={disableFields}
          onSelect={(selectedOption) => handleChange('cliente', selectedOption)}
          onClear={() => handleChange('cliente', '')}
          required={true}
        />
        <AutocompleteWithClear
          label="Natureza Op."
          options={naturezasOperacao}
          displayField="descricaoCompleta"
          value={localData.naturezaOperacao || ''}
          disabled={disableFields}
          onChange={(newValue) => handleChange('naturezaOperacao', newValue)}
          onSelect={(selectedOption) =>
            handleChange('naturezaOperacao', selectedOption)
          }
          onClear={() => handleChange('naturezaOperacao', '')}
          required={true}
        />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
        <AutocompleteWithClear
          label="Forma de Pagamento"
          options={formasPagamento}
          displayField="descricao"
          value={localData.formaPagamento || ''}
          onChange={(newValue) => handleChange('formaPagamento', newValue)}
          disabled={disableFields}
          onSelect={(selectedOption) =>
            handleChange('formaPagamento', selectedOption)
          }
          onClear={() => handleChange('formaPagamento', '')}
          required={true}
        />
        <AutocompleteWithClear
          label="Condição de Pagamento"
          options={filteredCondicoesPagamento}
          displayField="descricao"
          value={localData.condicaoPagamento || ''}
          onChange={(newValue) => handleChange('condicaoPagamento', newValue)}
          onSelect={(selectedOption) => handleConditionSelect(selectedOption)}
          disabled={disableFields}
          onClear={() => handleChange('condicaoPagamento', '')}
          required={true}
        />
        <TextField
          label="Vendedor"
          variant="outlined"
          size="small"
          fullWidth
          disabled={disableFields}
          InputProps={{ readOnly: true }}
          value={localData.vendedor || ''}
          onChange={(e) => handleChange('vendedor', e.target.value)}
        />


        <TextField
          label="Obs Pedido"
          variant="outlined"
          multiline
          rows={4}
          fullWidth
          value={localData.obsPedido || ''}
          onChange={(e) => handleChange('obsPedido', e.target.value)}
          disabled={disableFields}
        />
     
      </Box>

    </>
  );
}

export default DadosGerais;
